import { h } from "preact";

import Link from "../../../../foundation/router/Link";
import classname from "../../../../foundation/utils/classname";
import Dialog, { DialogProps } from "..";

import styles from "./OnboardingDialog.module.css";

interface Props extends Pick<DialogProps, "class" | "title" | "description" | "children" | "onClose"> {
    learnMoreUrl: string;
}

export default function OnboardingDialog({
    learnMoreUrl,
    class: cssClass,
    ...otherProps
}: Props) {
    return (
        <Dialog
            {...otherProps}
            class={classname(styles.onboardingDialog, cssClass)}
            primaryButtonProps={{
                children: "Continue tour"
            }}
            secondaryButtonProps={{
                children: <Link to={learnMoreUrl} isExternal>Learn more</Link>
            }}/>
    );
}
